/*
 * @Description: 路由配置文件
 * @Author: juanjuanhui
 * @Date: 2023-12-12 20:50:40
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-05-16 15:04:29
 */

import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Spark/index"),
    // redirect: "/spark",
    meta: {
      keepAlive: false, // 不需要缓存
    },
    // children: [
    //   {
    //     path: "/login",
    //     name: "login",
    //     component: () => import("@/views/Login"),
    //     meta: {
    //       keepAlive: false,
    //     },
    //   },
    //   {
    //     path: "/index",
    //     name: "spark",
    //     component: () => import("@/views/Spark/index"),
    //     meta: {
    //       keepAlive: false,
    //     },
    //   },
    // ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login/index"),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/wechat-login",
    name: "wechatLogin",
    component: () => import("@/views/Login/WechatLoading"),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/history-spark",
    name: "HistorySparkList",
    component: () => import("@/views/HistorySpark/RecordList"),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/test",
    name: "Test",
    component: () => import("@/views/Spark/test"),
    meta: {
      keepAlive: false, // 不需要缓存
    },
  },
  
];

const router = new VueRouter({
  mode: "history",
  base: "",
  routes,
});
export default router;
